import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

const Login = () => {
  return (
    <>
      <footer className="py-5 mt-auto">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="12">
              <div className="copyright text-center text-xl-left text-muted">
                © {new Date().getFullYear()}{" "}
                <Link to="#" className="font-weight-bold ml-1">
                  Copyright © 2025 Abhijeet Danve/Rheum Solutions LLC. All
                  rights reserved. The A-Tool&copy; is registered with the U.S.
                  Copyright Office
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Login;
